export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/icon-main-kw-logo-c064d47a4752f4f9b2549752c782c855.svg";